import React, {Component} from 'react';
import Header from "../header";
import Footer from "../footer";


class AboutUs extends Component {
    render() {
        return (
            <div>
                <Header />
                <main className="contact-page">
                    <div className="container">
                        <div className="contact-page-container">
                            <h1> İletişim </h1>

                            <div className="contact-page-content">
                                <div className="d-flex">
                                    <div className="phone">
                                        <i className="material-icons">phone</i>
                                        <div className="d-flex-content">
                                            <strong> Telefon </strong>
                                            <span> +90 542 481 23 44</span>
                                            <span> +90 505 895 82 08 </span>
                                        </div>
                                    </div>

                                    <div className="address">
                                        <i className="material-icons">location_on</i>
                                        <div className="d-flex-content">
                                            <strong> Adres </strong>
                                            <address>
                                                Ankara Ticaret Borsası (ATB)<br/>
                                                E-Blok No:119 Macunköy<br/>
                                                Yenimahalle/Ankara
                                            </address>
                                        </div>
                                    </div>

                                    <div className="mail">
                                        <i className="material-icons">email</i>
                                        <div className="d-flex-content">
                                            <strong> Email </strong>
                                            <span> saydamalbum@gmail.com </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="map">
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3058.673510997717!2d32.7661413!3d39.9486921!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDU2JzU1LjAiTiAzMsKwNDYnMDUuNiJF!5e0!3m2!1str!2str!4v1521906048620" width="900" height="600" frameborder="0" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        );
    }
}

export default AboutUs;


// WEBPACK FOOTER //
// ./src/components/contact.js